<div class="row">
  <div class="col-12 col-lg-6">
    <h3>{{ 'My children' | translate }}</h3>
    <p>{{ 'Add and edit your children' | translate }}</p>
  </div>
</div>
<router-outlet (activate)="onActivate($event)"></router-outlet>
<app-children-list [children]="partner.children" (eventListItemClicked)="childListItemClicked($event)"></app-children-list>
